import { Mail, X, Brain, CheckCircle, FileText } from "lucide-react";

export default function EmailDetailModal({ email, onClose }) {
  if (!email) return null;

  const statusBadge = email.client_identified 
    ? <span className="px-2 py-1 bg-emerald-500/20 text-emerald-400 rounded text-xs">Identifié</span>
    : email.processed 
    ? <span className="px-2 py-1 bg-orange-500/20 text-orange-400 rounded text-xs">À rattacher</span>
    : <span className="px-2 py-1 bg-amber-500/20 text-amber-400 rounded text-xs">En attente</span>;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80" onClick={onClose}>
      <div className="bg-slate-900 border border-slate-700 rounded-xl w-full max-w-3xl max-h-[85vh] mx-4" onClick={e => e.stopPropagation()}>
        <div className="p-4 border-b border-slate-700 flex items-center justify-between">
          <h3 className="font-semibold flex items-center gap-2">
            <Mail className="w-5 h-5 text-blue-400" />
            Détail de l'email
          </h3>
          <button onClick={onClose} className="p-2 hover:bg-slate-700 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5 overflow-y-auto max-h-[calc(85vh-80px)]">
          <h4 className="text-lg font-medium mb-3">{email.subject}</h4>
          
          <div className="bg-slate-800/50 rounded-lg p-4 mb-4">
            <p className="mb-2"><span className="text-slate-500">De:</span> <span className="text-blue-400">{email.from}</span></p>
            <p className="mb-2"><span className="text-slate-500">Date:</span> {email.date ? new Date(email.date).toLocaleString('fr-FR') : 'N/A'}</p>
            <p><span className="text-slate-500">Statut:</span> {statusBadge}</p>
          </div>

          {email.summary && (
            <div className="bg-purple-500/10 border border-purple-500/30 rounded-lg p-4 mb-4">
              <p className="text-xs text-purple-400 mb-2 flex items-center gap-2">
                <Brain className="w-4 h-4" /> Résumé SAN-IA
              </p>
              <p className="text-sm text-purple-300">{email.summary}</p>
            </div>
          )}

          <div className="bg-slate-800/50 rounded-lg p-4">
            <p className="text-xs text-slate-500 mb-3">Contenu</p>
            <pre className="text-sm text-slate-300 whitespace-pre-wrap max-h-[300px] overflow-y-auto">
              {email.body || email.body_preview || 'Contenu non disponible'}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
}
